import logo from './logo.svg';
import './App.css';
import './calc_back/style.css'
import react,{useState,useEffect} from 'react'
const  App = ()=> {
    const [xInput,setXInput] = useState(null)
    const [yInput,setYInput] = useState(null)
    const [zInput,setZInput] = useState(null)
    const [xText,setXText] = useState('')
    const [yText,setYText] = useState('')
    const [zText,setZText] = useState('')
    const [shouldRound,setShouldRound] = useState(false)

    // let xInput = document.getElementById('xSize')?.value;
    // let yInput = document.getElementById('ySize')?.value;
    // let zInput = document.getElementById('zSize')?.value;
  
    // so just round to closest 50mm?
    // so 330 + 150 = 480 but suggest 500
    // 330 + 100 = 430 but suggest 450
  
    //const shouldRound = document.getElementById('round').checked;
const getText = (params) =>{
  let {type,length} = params
  console.log("style,length",type,length)
  if(isNaN(length) || length <= 0)return  `please enter a number for ${type} size`

  switch(type) {
    case 'x':{
      let val1 = parseFloat(length) + 150.0;
      let val2 = val1 - 50.0;
      return `X will need: 6x ${val1}mm, 1x ${val2}mm extrusions and 1x ${val1 - 50.0}mm MGN9C rail`
    }
    case 'y':{
      let val1 = parseFloat(length);
      let val2 = val1 + 150.0;
      return `Y will need: 4x ${val2}mm, 2x ${val1}mm extrusions and 2x ${val1 + 150}mm MGN12C rails`
    }
    case 'z':{
      let val1 = parseFloat(length) + 100.0;
      return `Z will need: 5x ${val1}mm extrusions and 3x ${val1}mm MGN9C rails`
    }
    default: 
      return 'Error'
  }


  

}
    const roundValue = (value)=>{
      if(!value || value <=0) return null;
      return Math.ceil(value/50)*50
    }
    const calculateXYZ = (val)=>{
      return  ( shouldRound?roundValue(val):val)
    }
    const setRailItem = (params) =>{
      let {type,value,setValue,setText} = params
      let length = calculateXYZ(value);
      setValue(value);
      setText(getText({type,length}))

    }
useEffect(()=>{
  setRailItem({type:'x',value:xInput,setValue:setXInput,setText:setXText})
  setRailItem({type:'y',value:yInput,setValue:setYInput,setText:setYText})
  setRailItem({type:'z',value:zInput,setValue:setZInput,setText:setZText})
},[shouldRound])

  
  return (
    <div style={{textAlign:"center"}}>
      <h1>Rook 2020 Scalable Extrusion Calculator</h1>
      <p>All credit for this tool goes to Icesythe7, Martin42 and joejoe!</p>
      <h2>Input your desired print-volume</h2>
      <div class="inputs">
        <input value={xInput} type="number" id="xSize" placeholder="X Size" required onChange={(e)=>{
          console.log(e.currentTarget.value)
          setRailItem({type:'x',value:e.currentTarget.value,setValue:setXInput,setText:setXText})
        }} />
        <input value={yInput} type="number" id="ySize" placeholder="Y Size" required onChange={(e)=>{
          setRailItem({type:'y',value:e.currentTarget.value,setValue:setYInput,setText:setYText})

        }}/>
        <input value={zInput} type="number" id="zSize" placeholder="Z Size" required onChange={(e)=>{
          setRailItem({type:'z',value:e.currentTarget.value,setValue:setZInput,setText:setZText})

        }}/>
      </div>

      <div style={{textAlign:"center"}}>
      <input type="checkbox" id="round" onChange={()=>setShouldRound(prevRound=>!prevRound)} checked={shouldRound} />
      <label for="round">Round to nearest avaliable sizes</label>

      <h3> Please note, the calculator can round up to the nearest 50mm because MGN rails are often sold in 50mm increments</h3>
      <hr />

      <p id="xOutput">{xText}</p>

      <p id="yOutput">{yText}</p>

      <p id="zOutput">{zText}</p>
      </div>
      
    </div>
  );
}

export default App;
